import { Troubleshoot } from "@mui/icons-material";
import { Switch } from "@mui/material";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { ProfileStorage, useDebugMode } from "@ryde/shared";

import { LiveMapDiagnosticsPanelStyled } from "./live-map.styled";

interface ILiveMapDiagnosticsControlProps {
  /** Short label for narrow mobile toolbars (e.g. "diagn."). */
  compactLabel?: boolean;
}

export const LiveMapDiagnosticsControl: FC<ILiveMapDiagnosticsControlProps> = ({
  compactLabel = false,
}) => {
  const { t } = useTranslation();
  const {
    debugMode,
    hasDebugModeQueryParam,
    isLocalOrDebugOrTestOrStagingMode,
    setDebugMode,
  } = useDebugMode();
  const isHybridMode = ProfileStorage.isHybridMode;

  if (isHybridMode) {
    return null;
  }

  if (!isLocalOrDebugOrTestOrStagingMode && !hasDebugModeQueryParam) {
    return null;
  }

  return (
    <LiveMapDiagnosticsPanelStyled $compact={compactLabel}>
      {compactLabel ? (
        <Troubleshoot
          className="diagnostics_icon"
          aria-label={t("rideMap.DIAGNOSTICS")}
          fontSize="small"
        />
      ) : (
        <span className="diagnostics_label">{t("rideMap.DIAGNOSTICS")}</span>
      )}
      <Switch
        size="small"
        checked={debugMode || false}
        onChange={event => {
          setDebugMode?.(event.target.checked || false);
        }}
        name="diagnosticsMode"
      />
    </LiveMapDiagnosticsPanelStyled>
  );
};
